(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/add-club.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/add-club.js');
"use strict";

(function (svs, React) {
  'use strict';

  class AddClub extends React.Component {
    constructor(props) {
      super(props);
      this.handleSave = this.handleSave.bind(this);
    }
    componentDidMount() {
      const welcomeArticle = svs.grassroots_partner.data.cms.welcomeArticle;
      const welcome = document.getElementById('welcome');
      welcome.innerHTML = welcomeArticle;
      const supportArticle = svs.grassroots_partner.data.cms.supportArticle;
      const support = document.getElementById('support');
      support.innerHTML = supportArticle;
    }
    handleSave() {
      this.props.showErrorMessage('');
      if (!this.rfNumber.value || !this.email.value) {
        this.props.showErrorMessage('Båda fälten måste vara ifyllda');
        return;
      }
      const options = {
        method: 'POST',
        path: '/partner/1/admin/dssreceivers',
        data: {
          rfno: this.rfNumber.value,
          email: this.email.value,
          hasapprovedterms: true
        }
      };
      const successFunc = res => {
        this.props.setUserName(res.dssReceiverName);
        if (res.alreadyActive) {
          this.props.history.push('/inloggningstangd');
        } else {
          this.props.history.push('/foreningansluten');
        }
        this.props.setTerms(false);
      };
      const errorFunc = err => {
        const knownException = err.responseJSON.error.message.split(':%20')[1];
        const error = knownException ? svs.grassroots_partner.data.cms.errorMessages[knownException] : 'Någonting gick fel';
        this.props.showErrorMessage(error);
      };
      svs.core.jupiter.call(options, successFunc, errorFunc);
    }
    render() {
      const error = this.props.errorMessage ? 'error-border' : '';
      const className = "js-input std-input ".concat(error);
      return React.createElement("div", {
        className: "f-content"
      }, React.createElement("div", {
        className: "col-xs-12 margin-bottom-1 bg-white"
      }, React.createElement("div", {
        className: "col-lg-6 col-lg-offset-3 padding-xs-1"
      }, React.createElement("h2", {
        className: "align-center"
      }, "Anslut f\xF6rening"), React.createElement("span", {
        className: "f-bold"
      }, "V\xE4lkomna till Gr\xE4sroten!"), React.createElement("div", null, ' ', React.createElement("p", {
        id: "welcome"
      })), React.createElement("form", {
        className: "padding-bottom",
        ref: input => {
          this.form = input;
        }
      }, React.createElement("div", {
        className: "control-group"
      }, React.createElement("label", {
        className: "label-heading",
        htmlFor: "rfNumber"
      }, "F\xF6reningsnummer"), React.createElement("input", {
        className: className,
        ref: input => {
          this.rfNumber = input;
        },
        type: "text"
      }), React.createElement("label", {
        className: "label-heading",
        htmlFor: "email"
      }, "E-postadress"), React.createElement("input", {
        className: className,
        ref: input => {
          this.email = input;
        },
        type: "email"
      }), React.createElement("div", {
        className: "error",
        style: {
          padding: '6px 22px'
        }
      }, this.props.errorMessage), React.createElement("div", {
        className: "form-toggle padding-1"
      }, React.createElement("input", {
        className: "form-toggle-input form-toggle-checkbox form-toggle-default ",
        id: "terms",
        name: "",
        onClick: event => this.props.setTerms(event.target.checked),
        type: "checkbox"
      }), React.createElement("label", {
        className: "form-label form-label-align-left",
        htmlFor: "terms",
        style: {
          display: 'inline-block'
        }
      }, React.createElement("div", {
        className: "form-label-btn "
      })), React.createElement("div", {
        className: "form-label-text margin-left",
        style: {
          display: 'inline-block',
          verticalAlign: 'top'
        }
      }, React.createElement("div", {
        className: "form-label-text-content"
      }, "Jag godk\xE4nner", ' ', React.createElement("a", {
        className: "link",
        href: svs.grassroots_partner.data.cms.termsPdf,
        rel: "noopener noreferrer",
        target: "_blank"
      }, "villkoren"), ' ', "f\xF6r Gr\xE4sroten"))), React.createElement("input", {
        className: "btn btn-300 btn-inverted margin-bottom w100",
        disabled: !this.props.checked,
        onClick: this.handleSave,
        type: "button",
        value: "Anslut"
      }))), React.createElement("div", null, ' ', React.createElement("p", {
        id: "support"
      })), React.createElement("a", {
        className: "padding-bottom-1 align-center block",
        href: svs.grassroots_partner.data.cms.links.readMoreUrl
      }, "L\xE4s mer om Gr\xE4sroten"), React.createElement("a", {
        className: "padding-bottom-1 align-center block",
        href: svs.grassroots_partner.data.cms.termsPdf
      }, "L\xE4s Villkoren (pdf)"))));
    }
  }
  const mapStateToProps = state => ({
    checked: state.grassroot.checked,
    errorMessage: state.grassroot.errorMessage
  });
  const mapDispatchToProps = dispatch => ({
    setTerms: value => {
      dispatch(svs.grassroots_partner.actions.setTerms(value));
    },
    setUserName: value => {
      dispatch(svs.grassroots_partner.actions.setUserName(value));
    },
    showErrorMessage: message => {
      dispatch(svs.grassroots_partner.actions.showErrorMessage(message));
    }
  });
  svs.grassroots_partner.AddClub = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(AddClub);
})(svs, React);

 })(window);